import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1a3b6f7d")
const _hoisted_1 = { class: "lbp-review-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Project Name", -1)
const _hoisted_3 = { class: "text-xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Project Website", -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "lbp-review-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Token", -1)
const _hoisted_8 = { class: "text-xl items-center flex" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Token Contract Address", -1)
const _hoisted_10 = { class: "text-xl" }
const _hoisted_11 = { class: "lbp-review-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Twitter URL", -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 1,
  class: "text-xl"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Medium URL", -1)
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 1,
  class: "text-xl"
}
const _hoisted_18 = { class: "lbp-review-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Discord URL", -1)
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 1,
  class: "text-xl"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Telegram URL", -1)
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "text-xl"
}
const _hoisted_25 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Banner Image", -1)
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Project Description", -1)
const _hoisted_30 = { class: "whitespace-pre-line" }
_popScopeId()

import useLgeCreateState from '@/embr/lbp/composables/useLgeCreateState';
import BalTextInput from '@/components/_global/BalTextInput/BalTextInput.vue';
import useTokens from '@/composables/useTokens';
import { computed } from 'vue';
import BalAsset from '@/components/_global/BalAsset/BalAsset.vue';


export default _defineComponent({
  setup(__props) {

const { data } = useLgeCreateState();
const { getToken } = useTokens();

const launchToken = computed(() => getToken(data.value.tokenContractAddress));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).name), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("a", {
          href: _unref(data).websiteUrl,
          class: "text-green-400 text-xl",
          target: "_blank"
        }, _toDisplayString(_unref(data).websiteUrl), 9, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(_unref(launchToken).name) + " (" + _toDisplayString(_unref(launchToken).symbol) + ")  ", 1),
          _createVNode(BalAsset, {
            address: _unref(launchToken).address,
            iconURI: _unref(data).tokenIconUrl
          }, null, 8, ["address", "iconURI"])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(launchToken).address), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", null, [
        _hoisted_12,
        (_unref(data).twitterUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(data).twitterUrl,
              class: "text-green-400 text-xl",
              target: "_blank"
            }, _toDisplayString(_unref(data).twitterUrl), 9, _hoisted_13))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, "n/a"))
      ]),
      _createElementVNode("div", null, [
        _hoisted_15,
        (_unref(data).mediumUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(data).mediumUrl,
              class: "text-green-400 text-xl",
              target: "_blank"
            }, _toDisplayString(_unref(data).mediumUrl), 9, _hoisted_16))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, "n/a"))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", null, [
        _hoisted_19,
        (_unref(data).discordUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(data).discordUrl,
              class: "text-green-400 text-xl",
              target: "_blank"
            }, _toDisplayString(_unref(data).discordUrl), 9, _hoisted_20))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, "n/a"))
      ]),
      _createElementVNode("div", null, [
        _hoisted_22,
        (_unref(data).telegramUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(data).telegramUrl,
              class: "text-green-400 text-xl",
              target: "_blank"
            }, _toDisplayString(_unref(data).telegramUrl), 9, _hoisted_23))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, "n/a"))
      ])
    ]),
    (_unref(data).bannerImageUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("img", {
            src: _unref(data).bannerImageUrl,
            width: "400",
            class: "max-w-full"
          }, null, 8, _hoisted_27)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(data).description), 1)
    ])
  ], 64))
}
}

})